module.exports = __webpack_public_path__ + "static/under-construction-b39ab1c684e72c81e38fb8bdb7679baf.gif";